import { defineComponent, ref, onMounted, computed, } from '@vue/composition-api';
import { getUserSurveysList } from '@/api/v2/requests/surveys';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import SurveyHeader from '@/views/Brand/Surveys/Users/_components/SurveyHeader.vue';
import SurveyAnswersList from './_components/SurveyAnswersList.vue';
export default defineComponent({
    name: 'PlaceManagerSurvey',
    components: {
        TableLoader,
        SurveyHeader,
        SurveyAnswersList,
    },
    setup(_, ctx) {
        const isLoading = ref(false);
        const survey = ref(null);
        const aggregatedStatus = ref(undefined);
        const surveyAnswers = ref([]);
        const surveyComments = ref([]);
        const surveyFiles = ref([]);
        const surveyStatuses = ref([]);
        const surveyUserId = ref('');
        const userFullName = ref('');
        const placeName = ref('');
        const surveyPlaceId = ref('');
        const surveyId = computed(() => ctx.root.$route.params.surveyId);
        const placeId = computed(() => ctx.root.$route.query.placeId);
        const fetchSurvey = async () => {
            if (!surveyId.value)
                return;
            isLoading.value = true;
            try {
                const result = await getUserSurveysList({
                    surveyId: surveyId.value,
                    placeId: placeId.value,
                    perPage: 1,
                    page: 1,
                });
                const mySurvey = result.nodes[0];
                survey.value = mySurvey?.survey || null;
                aggregatedStatus.value = mySurvey?.aggregatedStatus || undefined;
                surveyAnswers.value = mySurvey?.answers || [];
                surveyComments.value = mySurvey?.comments || [];
                surveyFiles.value = mySurvey?.files || [];
                surveyStatuses.value = mySurvey?.statuses || [];
                surveyUserId.value = mySurvey?.id || '';
                userFullName.value = '';
                placeName.value = mySurvey?.place?.name || '';
                surveyPlaceId.value = mySurvey?.place?.id || '';
            }
            catch (error) {
                ctx.root.$toast.error(ctx.root.$t('brand-surveys.details.error-fetching'));
            }
            finally {
                isLoading.value = false;
            }
        };
        onMounted(() => {
            fetchSurvey();
        });
        return {
            isLoading,
            survey,
            aggregatedStatus,
            surveyAnswers,
            surveyComments,
            surveyFiles,
            surveyStatuses,
            surveyUserId,
            userFullName,
            placeName,
            surveyPlaceId,
            fetchSurvey,
        };
    },
});
